import React, { useState, useEffect, useContext } from "react";
import { auth } from "../util/firebase";

let logoutTimer;

const AuthContext = React.createContext({
  isLoggedIn: false,
  id: "",

  login: () => {},
  logout: () => {},
  signUp: () => {},
  getUser: () => {},
});

export function useAuth() {
  return useContext(AuthContext);
}

export const AuthContextProvider = (props) => {
  const [currentUser, setCurrentUser] = useState({});
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  function logout() {
    // clear the local storage
    localStorage.removeItem("userId");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("isLoggedIn");
    return auth.signOut();
  }

  function login(email, password) {
    return auth
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        const userId = userCredential?.user?.multiFactor?.user?.uid;

        // store the user id in local storage
        localStorage.setItem("userId", userId);

        // store the user login status in local storage
        localStorage.setItem("isLoggedIn", true);

        // store the user email in local storage
        localStorage.setItem("userEmail", email);
      })
      .catch((error) => {
        if (error.code === "auth/user-not-found") {
          setErrorMessage("User not found");
        }
        if (error.code === "auth/wrong-password") {
          setErrorMessage("Wrong password");
        }
        if (error.code === "auth/too-many-requests") {
          setErrorMessage("Too many requests");
        }
        if (error.code === "auth/user-disabled") {
          setErrorMessage("User disabled");
        }
        if (error.code === "auth/user-token-expired") {
          setErrorMessage("User token expired");
        }
        if (error.code === "auth/invalid-email") {
          setErrorMessage("Invalid email");
        }
        if (error.code === "auth/email-already-in-use") {
          setErrorMessage("Email already in use");
        }
        if (error.code === "auth/weak-password") {
          setErrorMessage("Weak password");
        }
        if (error.code === "auth/network-request-failed") {
          setErrorMessage("Network request failed");
        }
        if (error.code === "auth/operation-not-allowed") {
          setErrorMessage("Operation not allowed");
        }
        if (error.code === "auth/invalid-api-key") {
          setErrorMessage("Invalid api key");
        }

        console.log(error.message, errorMessage);
      });
  }

  function signUp(email, password) {
    return auth.createUserWithEmailAndPassword(email, password);
  }

  function forgotPassword(email) {
    return auth.sendPasswordResetEmail(email);
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setCurrentUser(user);
        setLoading(false);
      } else {
        setCurrentUser(null);
        setLoading(false);
      }

      return unsubscribe;
    });
  }, []);

  const contextValue = {
    currentUser,
    setCurrentUser,
    forgotPassword,
    login: login,
    logout: logout,
    signUp: signUp,
    errorMessage,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {!loading && props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
